// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_qg-8";
export var editMode = "_qg-3";
export var headerRow = "_qg-a";
export var headerTitle = "_qg-b";
export var product = "_qg-1";
export var productDetails = "_qg-5";
export var productDivider = "_qg-7";
export var productImage = "_qg-2";
export var productInfo = "_qg-4";
export var productTitle = "_qg-6";
export var strikethrough = "_qg-9";
export var upsellProductsCard = "_qg-0";